/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as queryString from 'query-string';
import PropTypes from 'prop-types';
import CreateAccount from '../../../components/CreateAccount';
import { registerUserAccount, fetchAuthenticatedUser } from '../../../actions';
import config from '../../../../config';
import { screens } from '../../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import presetClaimedUser from '../../../components/hocs/presetClaimedUser';
import { isUtrActivationInProgress } from '../../../utils/activateUtr';
import { formatRegistrationCampaign, getThirdPartyCompanyIdFromUrl } from '../../../utils/oauth';
import { gtag } from '../../../components/Analytics/gtag';

import styles from './join.scss';
import { sportTypeIds } from '../../../utils/eventConstants';
import TennisAustraliaLogin from '../../../components/TennisAustraliaLogin';
import AppleLoginV3 from '../../../components/AppleLoginV3';
import FacebookLoginV2 from '../../../components/FacebookLoginV2';
import withAuth from '../../../components/hocs/withAuth';

class Join extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.signInClicked = this.signInClicked.bind(this);
        if (props.auth && props.auth.user) {
            props.history.replace('/home'); // Go to dashboard if logged in
        }
        this.state = {
            signupError: '',
        };
    }

    signInClicked(email) {
        const { inPopUp, moveToScreen, location, history } = this.props;
        if (inPopUp) {
            moveToScreen(screens.LOGIN, email);
        } else {
            const parsed = queryString.parse(location.search);
            const { return: returnUrl } = parsed;
            const loginParsed = parsed;
            if (email) {
                loginParsed.email = email;
            }
            if (returnUrl) {
                loginParsed.next = encodeURIComponent(returnUrl);
                delete loginParsed.return;
            }
            const loginUrl = `/login${Object.keys(loginParsed).length > 0 ? `?${queryString.stringify(loginParsed, { encode: false })}` : ''}`;
            history.push(loginUrl);
        }
    }

    async submit(values) {
        try {
            const formValues = values;
            this.setState({
                submitting: true,
            });
            if (this.props.registrationCampaign) {
                formValues.registrationCampaign = this.props.registrationCampaign;
            } else {
                const { location } = this.props;
                const thirdPartyCompanyId = getThirdPartyCompanyIdFromUrl(location?.search);
                if (thirdPartyCompanyId) {
                    formValues.registrationCampaign = formatRegistrationCampaign(thirdPartyCompanyId);
                }
            }
            if (this.props.onboardFlow) {
                formValues.onboardFlow = this.props.onboardFlow;
            }
            await this.props.registerUserAccount({
                ...values,
                email: values.email.trim(),
            });
            gtag('event', {
                category: 'Member Joined',
                context: `Reg Campaign: ${values.registrationCampaign} - Onboard Flow: ${values.onboardFlow}`,
            });
            // segment call - mapped to GA4
            if (window && window.analytics) {
                window.analytics.track('Member Joined', {
                    registrationCampaig: values.registrationCampaign,
                    onboardFlow: values.onboardFlow,
                });
            }
            this.setState({
                submitting: false,
            });
        } catch (err) {
            if (err.response && err.response.data && err.response.data.errors) {
                this.setState({
                    submitting: false,
                    // eslint-disable-next-line no-underscore-dangle
                    signupError: err.response.data.errors._error.errors[0].errorMessage,
                });
            } else {
                this.setState({
                    submitting: false,
                    signupError: 'Registration Failed',
                });
            }
            return;
        }

        const { activateUtr } = this.props;

        if (!this.props.inPopUp) {
            let parsed = queryString.parse(this.props.location.search);

            const utrActivationInProgress = isUtrActivationInProgress(activateUtr);
            if (utrActivationInProgress) {
                parsed = {
                    ...parsed,
                    activationType: activateUtr.activationType,
                    activationToken: activateUtr.activationToken,
                };
            }

            const initiatingSportTypeId = sportTypeIds[this.props.match?.params?.initiatingSportType?.toUpperCase()];
            if (initiatingSportTypeId) {
                parsed = {
                    ...parsed,
                    initiatingSportTypeId,
                };
            }

            window.location.href = `/onboarding${Object.keys(parsed).length > 0 ? `?${queryString.stringify(parsed, { encode: true })}` : ''}`;
        } else {
            await this.props.fetchAuthenticatedUser();
            this.props.moveToNextScreen();
        }
    }

        render() {
            const { forceMobileUi, activateUtr } = this.props;
            const { signupError, submitting } = this.state;
            const parsed = queryString.parse(this.props.location.search);

        let parsedTitle = '';
        let parsedSubTitle = '';

        switch (parsed.flow) {
            case 'club_create':
                parsedTitle = 'Create your UTR Sports account';
                parsedSubTitle = 'In order to complete your UTR Sports Pro Club, you need an account.';
                break;
            case 'high_school_club_create':
                parsedTitle = 'Create your UTR Sports account';
                parsedSubTitle = 'In order to complete your UTR Sports High School Club, you need an account.';
                break;
            case 'tournament_club_create':
                parsedTitle = 'Create your UTR Sports account';
                parsedSubTitle = 'In order to create your UTR Sports event, you need an account.';
                break;
            default:
                parsedTitle = `Create your profile, get rated, and start playing!`;
                parsedSubTitle = '';
                break;
        }

        const title = this.props.title || parsedTitle;
        const subTitle = this.props.subTitle || parsedSubTitle;

        const utrActivationInProgress = isUtrActivationInProgress(activateUtr);
        const defaultValues = isUtrActivationInProgress(activateUtr) ? { email: activateUtr.user.email } : null;

        return (
            <div className={`${styles.section} ${forceMobileUi ? styles.popUp : ''}`}>
                <div className="container">
                    <div className="row">
                        <div className={`${forceMobileUi ? 'col' : 'col-12 col-md-6 offset-md-3'}`}>
                            <div className={`${styles.authCard}`}>
                                {this.props.partnerLogos && this.props.partnerLogos()}
                                {parsed.flow === 'club_create' && (
                                    <div className="step-header">
                                        <div className="text-highlight2" data-testid="join.page.step-indicator">STEP 4/6</div>
                                    </div>
                                )}
                                {parsed.flow === 'high_school_club_create' && (
                                    <div className="step-header">
                                        <div className="text-highlight2" data-testid="join.page.step-indicator">STEP 4/5</div>
                                    </div>
                                )}
                                {parsed.flow === 'tournament_club_create' && (
                                    <div className="step-header">
                                        <div className="text-highlight2" data-testid="join.page.step-indicator">STEP 4/5</div>
                                    </div>
                                )}
                                <div className={`${styles.title}`} data-testid="join.page.title">
                                    {title}
                                </div>
                                <div className={styles.accentTitle}>
                                    <span data-testid="join.page.subtitle">{subTitle}</span>
                                </div>

                                <CreateAccount
                                    error={signupError}
                                    submitting={submitting}
                                    onSubmit={this.submit}
                                    signInClicked={this.signInClicked}
                                    defaultValues={defaultValues}
                                    themeV3
                                />
                                <div className={styles.tos}>
                                    <span data-testid="join.page.tos">By continuing, I agree to the <a href={`${config.marketingAppHost}/tos`} target="_blank" rel="noopener noreferrer" data-testid="join.page.tos-link">Terms of service</a>.</span>
                                </div>
                                {!utrActivationInProgress && (
                                <>
                                    <hr className="hr-text" data-content="or" />
                                    <FacebookLoginV2 flow="login" buttonText="Continue with Facebook" data-testid="join.page.facebook-btn" />
                                    <AppleLoginV3 flow="login" buttonText="Continue with Apple" data-testid="join.page.apple-btn" />
                                    <TennisAustraliaLogin data-testid="join.page.tennis-australia-btn" />
                                </>
                                )}
                                <p className={`${styles.text}`} data-testid="join.page.sign-in-text">Already have an account?&nbsp;
                                    <a
                                        className="cursor-pointer text-teal"
                                        onClick={() => this.signInClicked()}
                                        data-testid="join.page.sign-in-link"
                                    >
                                        Sign in.
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        registerUserAccount: (data) => dispatch(registerUserAccount(data)),
        fetchAuthenticatedUser: () => dispatch(fetchAuthenticatedUser()),
    };
}

function mapStateToProps({ auth, activateUtr }) {
    return { auth, activateUtr };
}

Join.propTypes = {
    registrationCampaign: PropTypes.string,
    location: PropTypes.instanceOf(Object).isRequired,
    auth: PropTypes.objectOf(PropTypes.any).isRequired,
};

Join.defaultProps = {
    registrationCampaign: '',
};

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(presetClaimedUser(Join)));
